import gql from 'graphql-tag'

export const CategoryTranslateFragment = gql`
  fragment CategoryTranslateFragment on CategoryTranslate {
    id
    categoryEnumType
    ngChatPromptCategory
    ngColor
    ngCreatedBy
    ngCreatedOn
    ngModifiedBy
    ngModifiedOn
    ngProjectId
    ngSequence
    ngSourceLanguage
    pform
    pid
    system
    userid
  }
`
